module.exports = __webpack_public_path__ + "static/media/test15_4.5613ae62.png";